<template src="./OverlaySubirArchivo.html"></template>
<script>
import Icono from "../Icono/Icono";
import { subirDocumentoOrdenes } from "../../apiService/request/CrudDocumentos";
export default {
  data() {
    return {
      file: [],
      descripcion: "",
      rules: [
        (value) =>
          !value || value.size < 5000000 || "El tamaño es mayor a 5 MB!",
      ],
      iconoBot:
        "M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,2c8,0,14.9,4.7,18.1,11.5C36.1,7.7,29.4,4,22,4C14.6,4,7.9,7.7,3.9,13.5C7.1,6.7,14,2,22,2z M41.6,22C39.7,31.3,31.5,38,22,38S4.3,31.3,2.4,22C4.3,12.7,12.5,6,22,6S39.7,12.7,41.6,22z M22,42c-8,0-14.9-4.7-18.1-11.5C7.9,36.3,14.6,40,22,40c7.4,0,14.1-3.7,18.1-9.5C36.9,37.3,30,42,22,42z M13,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,16,13,16z M13,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S15.2,26,13,26z M31,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S34.3,16,31,16z M31,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S33.2,26,31,26z",
    };
  },
  props: {
    overlaySubirArchivo: {
      type: Boolean,
      default: false,
    },
    nombreArchivo: {
      type: String,
      default: "",
    },
  },
  components: {
    Icono,
  },
  methods: {
    limpiarData() {
      this.file = [];
    },
    cerrarOverlaySubirArchivo() {
      this.limpiarData();
      this.$emit("cerrarOverlaySubirArchivo");
    },
    async enviarArchivo() {
      try {
        this.$store.dispatch("setCargando", true);
        let formData = new FormData();
        formData.append("fileCSV", this.file);
        formData.append("creado_por", this.$store.state.provider_email);
        formData.append("descripcion", this.descripcion);
        const respons = await subirDocumentoOrdenes(formData);
        alert(respons.data.message);
      } catch (error) {
        alert(`Se produjo un error al subir las órdenes ${error}`);
      } finally {
        this.cerrarOverlaySubirArchivo();
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./OverlaySubirArchivo.scss">
</style>


// WEBPACK FOOTER //
// src/components/OverlaySubirArchivo/OverlaySubirArchivo.vue